import React from "react";
import BannerBreadcrumb from "../Components/BannerBreadcrumb";

const AbroadScholarships = () => {
    const AbroadScholar = [
        {

            head: "Ms. Agatha Harrison Memorial Fellowship",
            des: "The Ms. Agatha Harrison Memorial Fellowship is a prestigious advanced research fellowship provided by the Indian Ministry of Human Resources and Development, supporting",
            listhead1: "Benefits Worth",
            listhead2: "Deadline",
            listhead3: "Country",
            listhead4: "Course Level",
            listhead5: "Special Restrictions",
            listhead6: "Scholarship Type",
            listdes1: "₹ 3,171,417",
            listdes2: "15 Jan 2025",
            listdes3: "United Kingdom",
            listdes4: "PhD",
            listdes5: "NA",
            listdes6: "Merit Based",
            extrades: "GBP 29,347",
        },
        {

            head: "Erasmus Mundus Scholarship",
            des: "The Erasmus Mundus Scholarship, funded by the European Union, offers financial support to students from developing countries to pursue prestigious joint master’s degree programs",
            listhead1: "Benefits Worth",
            listhead2: "Deadline",
            listhead3: "Country",
            listhead4: "Course Level",
            listhead5: "Special Restrictions",
            listhead6: "Scholarship Type",
            listdes1: "Variable",
            listdes2: "15 Jan 2025",
            listdes3: "Multiple",
            listdes4: "Masters",
            listdes5: "NA",
            listdes6: "Merit Based",
        },
        {

            head: "AAUW International Fellowships",
            des: "The funding to international women students for full-time study or research in the United States, empowering them to advance their academic and professional goals.",
            listhead1: "Benefits Worth",
            listhead2: "Deadline",
            listhead3: "Country",
            listhead4: "Course Level",
            listhead5: "Special Restrictions",
            listhead6: "Scholarship Type",
            listdes1: "Variable",
            listdes2: "15 Jan 2024",
            listdes3: "United States",
            listdes4: "Masters",
            listdes5: "NA",
            listdes6: "Merit Based",
        },
        {

            head: "UGRAD Scholarship USA",
            des: "The Global Undergraduate Exchange Program (also referred to as Global UGRAD Program) offers semester-long scholarships to exceptional undergraduate students",
            listhead1: "Benefits Worth",
            listhead2: "Deadline",
            listhead3: "Country",
            listhead4: "Course Level",
            listhead5: "Special Restrictions",
            listhead6: "Scholarship Type",
            listdes1: "Variable",
            listdes2: "15 Dec 2024",
            listdes3: "United States",
            listdes4: "Undergrad",
            listdes5: "NA",
            listdes6: "Merit Based",
        },
        {

            head: "Fulbright-Kalam Climate Fellowships 2024",
            des: "The Fulbright-Kalam Climate Fellowships support Indian Ph.D. scholars in conducting research in the United States, fostering collaboration to address global climate",
            listhead1: "Benefits Worth",
            listhead2: "Deadline",
            listhead3: "Country",
            listhead4: "Course Level",
            listhead5: "Special Restrictions",
            listhead6: "Scholarship Type",
            listdes1: "Variable",
            listdes2: "15 Jan 2024",
            listdes3: "United States",
            listdes4: "PhD",
            listdes5: "NA",
            listdes6: "Merit & Need Based",
        },
        {

            head: "KTH India Scholarship 2024",
            des: "With the help of an anonymous donation, the KTH India Scholarship Foundation was founded in 2012 and now grants two scholarships annually. The scholarship include",
            listhead1: "Benefits Worth",
            listhead2: "Deadline",
            listhead3: "Country",
            listhead4: "Course Level",
            listhead5: "Special Restrictions",
            listhead6: "Scholarship Type",
            listdes1: "Variable",
            listdes2: "15 Jan 2025",
            listdes3: "India",
            listdes4: "Undergrad",
            listdes5: "NA",
            listdes6: "Merit Based",
        },
        {

            head: "Orange Tulip Scholarship 2025",
            des: "Orange Tulip Scholarship (OTS) gives talented undergraduate, graduate, doctoral Indian students the opportunity to study in Netherlands with partial or full",
            listhead1: "Benefits Worth",
            listhead2: "Deadline",
            listhead3: "Country",
            listhead4: "Course Level",
            listhead5: "Special Restrictions",
            listhead6: "Scholarship Type",
            listdes1: "Variable",
            listdes2: "01 April 2025",
            listdes3: "Netherlands",
            listdes4: "Masters",
            listdes5: "NA",
            listdes6: "Merit Based",
        },
        {

            head: "Clarendon Scholarship",
            des: "The Clarendon Scholarships are fully-funded financial awards for graduate students at the University of Oxford, benefiting over 200 scholars annually with support for tuition and",
            listhead1: "Benefits Worth",
            listhead2: "Deadline",
            listhead3: "Country",
            listhead4: "Course Level",
            listhead5: "Special Restrictions",
            listhead6: "Scholarship Type",
            listdes1: "Variable",
            listdes2: "15 Jan 2025",
            listdes3: "United Kingdom",
            listdes4: "Masters",
            listdes5: "NA",
            listdes6: "Merit Based",
        },
        {

            head: "Scotland Saltire Scholarships",
            des: "The Scotland Saltire Scholarships offer financial support to international students pursuing on-campus master’s programs at universities across Scotland, promoting",
            listhead1: "Benefits Worth",
            listhead2: "Deadline",
            listhead3: "Country",
            listhead4: "Course Level",
            listhead5: "Special Restrictions",
            listhead6: "Scholarship Type",
            listdes1: "₹ 864,529",
            listdes2: "12 June 2023",
            listdes3: "United Kingdom",
            listdes4: "Others",
            listdes5: "NA",
            listdes6: "Merit Based",
            extrades: "GBP 8,000"
        },
        {

            head: "Narotam Sekhsaria Scholarship",
            des: "The Narotam Sekhsaria Scholarship provides interest-free education loans to outstanding Indian students, enabling them to pursue higher education at prestigious universities",
            listhead1: "Benefits Worth",
            listhead2: "Deadline",
            listhead3: "Country",
            listhead4: "Course Level",
            listhead5: "Special Restrictions",
            listhead6: "Scholarship Type",
            listdes1: "INR 2,000,000",
            listdes2: "15 Jan 2025",
            listdes3: "Multiple",
            listdes4: "-",
            listdes5: "NA",
            listdes6: "Merit Based",
        },
        {

            head: "KC Mahindra Scholarships",
            des: "The KC Mahindra Scholarship for postgraduate studies abroad is a need-based award for academically bright Indian students that offers INR 10 Lakhs to top three",
            listhead1: "Benefits Worth",
            listhead2: "Deadline",
            listhead3: "Country",
            listhead4: "Course Level",
            listhead5: "Special Restrictions",
            listhead6: "Scholarship Type",
            listdes1: "INR 1,000,000",
            listdes2: "15 Jan 2025",
            listdes3: "Multiple",
            listdes4: "-",
            listdes5: "NA",
            listdes6: "Need Based",
        },
        {

            head: "Cornell University Tata Scholarship 2025",
            des: "The Cornell University Tata Scholarship awards approximately 20 scholarships to deserving Indian students with academic merit & leadership skills pursuing",
            listhead1: "Benefits Worth",
            listhead2: "Deadline",
            listhead3: "Country",
            listhead4: "Course Level",
            listhead5: "Special Restrictions",
            listhead6: "Scholarship Type",
            listdes1: "1variable",
            listdes2: "15 Jan 2025",
            listdes3: "United States",
            listdes4: "Undergrad",
            listdes5: "NA",
            listdes6: "Need Based",
        },
    ]
    return (
        <>
            <BannerBreadcrumb head={"Boost Your Savings! Discover and apply for scholarships that fit your unique needs."} pagename={"Study Abroad Scholarships"} />
            <div className="scholarships-main">
                <div className="container">
                    <div className="row">
                        {AbroadScholar.map((item, index) => (
                            <div className="col-md-4 scholar-card-col">
                                <div className="scholar-card">
                                    <h6 className="scholar-head">{item.head}</h6>
                                    <p className="scholar-des">{item.des}</p>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h6 className="list-of-scholar">{item.listhead1}</h6>
                                            <p className="list-des">{item.listdes1} <br /> {item.extrades}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <h6 className="list-of-scholar">{item.listhead2}</h6>
                                            <p className="list-des">{item.listdes2}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <h6 className="list-of-scholar">{item.listhead3}</h6>
                                            <p className="list-des">{item.listdes3}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <h6 className="list-of-scholar">{item.listhead4}</h6>
                                            <p className="list-des">{item.listdes4}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <h6 className="list-of-scholar">{item.listhead5}</h6>
                                            <p className="list-des">{item.listdes5}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <h6 className="list-of-scholar">{item.listhead6}</h6>
                                            <p className="list-des">{item.listdes6} </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default AbroadScholarships;